import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPnLComparison } from "./pnlComparisonService";
import PnLComparisonTable from "./PnLComparisonTable";

const PnLComparisonPage = () => {
  const navigate = useNavigate();

  const [yearsData, setYearsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [numYears, setNumYears] = useState(5);

  useEffect(() => {
    fetchReport(numYears);
  }, []);

  const fetchReport = async (n) => {
    setLoading(true);
    setError(null);
    try {
      const data = await getPnLComparison(n);
      setYearsData(data.years || []);
    } catch (err) {
      setError("Failed to load comparison report. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleYearsChange = (n) => {
    setNumYears(n);
    fetchReport(n);
  };

  return (
    <div className="container-fluid">
      {/* ── Page Header ──────────────────────────────────────────────────── */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h3 className="mb-0">P&amp;L Comparison</h3>
          <small className="text-muted">
            Annual Profit &amp; Loss — side‑by‑side year comparison
          </small>
        </div>
        <button
          className="btn btn-secondary btn-sm"
          onClick={() => navigate("/dashboard")}
        >
          Back to Dashboard
        </button>
      </div>

      {/* ── Controls ─────────────────────────────────────────────────────── */}
      <div className="d-flex align-items-center gap-3 mb-4">
        <label className="form-label mb-0 fw-semibold">Number of Years:</label>
        <div className="btn-group" role="group" aria-label="Number of years">
          {[2, 3, 4, 5].map((n) => (
            <button
              key={n}
              type="button"
              className={`btn btn-sm ${
                numYears === n ? "btn-primary" : "btn-outline-primary"
              }`}
              onClick={() => handleYearsChange(n)}
            >
              {n}
            </button>
          ))}
        </div>
        <span className="text-muted small">
          Showing {numYears} year{numYears > 1 ? "s" : ""} of data
        </span>
      </div>

      {/* ── Content ──────────────────────────────────────────────────────── */}
      {loading ? (
        <div className="p-5 text-center text-muted">
          <div className="spinner-border text-primary mb-3" role="status" />
          <div>Loading comparison report…</div>
        </div>
      ) : error ? (
        <div className="alert alert-danger">{error}</div>
      ) : yearsData.length === 0 ? (
        <div className="alert alert-warning">No data available.</div>
      ) : (
        <PnLComparisonTable years={yearsData} />
      )}
    </div>
  );
};

export default PnLComparisonPage;
